export default "__VITE_ASSET__6d6b5ee2__"